import _classCallCheck from "C:\\Users\\Administrator\\Desktop\\KaporgLatestC\\KAPorg-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Administrator\\Desktop\\KaporgLatestC\\KAPorg-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\Administrator\\Desktop\\KaporgLatestC\\KAPorg-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _isNativeReflectConstruct from "C:\\Users\\Administrator\\Desktop\\KaporgLatestC\\KAPorg-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/isNativeReflectConstruct";
import _getPrototypeOf from "C:\\Users\\Administrator\\Desktop\\KaporgLatestC\\KAPorg-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\Administrator\\Desktop\\KaporgLatestC\\KAPorg-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
import { Polling } from "./polling.js";
/**
 * HTTP long-polling based on the built-in `fetch()` method.
 *
 * Usage: browser, Node.js (since v18), Deno, Bun
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/fetch
 * @see https://caniuse.com/fetch
 * @see https://nodejs.org/api/globals.html#fetch
 */
export var Fetch = /*#__PURE__*/function (_Polling) {
  function Fetch() {
    _classCallCheck(this, Fetch);
    return _callSuper(this, Fetch, arguments);
  }
  _inherits(Fetch, _Polling);
  return _createClass(Fetch, [{
    key: "doPoll",
    value: function doPoll() {
      var _this = this;
      this._fetch().then(function (res) {
        if (!res.ok) {
          return _this.onError("fetch read error", res.status, res);
        }
        res.text().then(function (data) {
          return _this.onData(data);
        });
      }).catch(function (err) {
        _this.onError("fetch read error", err);
      });
    }
  }, {
    key: "doWrite",
    value: function doWrite(data, callback) {
      var _this2 = this;
      this._fetch(data).then(function (res) {
        if (!res.ok) {
          return _this2.onError("fetch write error", res.status, res);
        }
        callback();
      }).catch(function (err) {
        _this2.onError("fetch write error", err);
      });
    }
  }, {
    key: "_fetch",
    value: function _fetch(data) {
      var _this3 = this;
      var _a;
      var isPost = data !== undefined;
      var headers = new Headers(this.opts.extraHeaders);
      if (isPost) {
        headers.set("content-type", "text/plain;charset=UTF-8");
      }
      (_a = this.socket._cookieJar) === null || _a === void 0 ? void 0 : _a.appendCookies(headers);
      return fetch(this.uri(), {
        method: isPost ? "POST" : "GET",
        body: isPost ? data : null,
        headers: headers,
        credentials: this.opts.withCredentials ? "include" : "omit"
      }).then(function (res) {
        var _a;
        // @ts-ignore getSetCookie() was added in Node.js v19.7.0
        (_a = _this3.socket._cookieJar) === null || _a === void 0 ? void 0 : _a.parseCookies(res.headers.getSetCookie());
        return res;
      });
    }
  }]);
}(Polling);